import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Small = ({ as = 'span', color, strong = false, ...rest }: TText) => (
  <TextBase {...rest} as={as} kind={strong ? 'body-extra-small-strong' : 'body-extra-small-regular'} color={color} />
);

export default Small;
